import { useQuery } from '@tanstack/react-query'

import { axios, QueryConfig } from '@apps-common/lib'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

export const QUERY_GET_UNIT_GENERIC_DETAILS = (unitId: string) => ['getUnitGenericDetails', unitId]

export const getUnitGenericDetails = async (unitId?: string, status?: string): Promise<IUnitGenericDetailsModel> =>
  axios.get(`/Unit/GetUnit?unitId=${unitId}&status=${status}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitGenericDetails

type Props = {
  config?: QueryConfig<QueryFnType>
  status?: string
  unitId?: string
}

export const useGetUnitGenericDetails = ({ config, status, unitId }: Props) =>
  useQuery({
    ...config,
    staleTime: 0,
    queryKey: QUERY_GET_UNIT_GENERIC_DETAILS(unitId || ''),
    queryFn: () => getUnitGenericDetails(unitId, status)
  })
